import React, {useState, useEffect} from 'react';
import "./header.scss";
import siteLogo from "../../images/riseuplogo.png";
import {Link, NavLink} from "react-router-dom";
import {FaTimes, FaClock} from "react-icons/fa";

const TIMEZONES = [
    { label: 'Toronto, ON', zone: 'America/Toronto' },
    { label: 'Surat, India', zone: 'Asia/Kolkata' },
];

function formatInZone(now, timeZone) {
    const time = new Intl.DateTimeFormat('en-US', {
        timeZone,
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    }).format(now);
    const date = new Intl.DateTimeFormat('en-US', {
        timeZone,
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    }).format(now);
    return { time, date };
}

function TimezoneBar() {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(id);
    }, []);

    return (
        <div className="header_timezone_bar">
            <div className="container">
                <div className="timezone_list">
                    <i className="tz_clock"><FaClock /></i>
                    {TIMEZONES.map(({ label, zone }) => {
                        const { time, date } = formatInZone(now, zone);
                        return (
                            <div className="timezone_item" key={label}>
                                <span className="tz_badge">{label}</span>
                                <span className="tz_time">{time}</span>
                                <span className="tz_date">{date}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default function Index() {

    const [toggleMobileMenu, setToggleMobileMenu] = useState(false);

    const controlMobileMenu = (e) => {
        setToggleMobileMenu(!toggleMobileMenu);
    }
    const closeMenu = (e) => {
        setToggleMobileMenu(false);
    }
    return (
        <header className="header_area header_v1 transparent_header">
            <TimezoneBar />
            <div className="container">
                <div className="site_menu">
                    <div className="row align-items-center">
                        <div className="col-lg-2">
                            <div className="brand">
                                <Link className="logo" to="/"><img src={siteLogo} className="img-fluid"
                                                                   alt="logo"/></Link>
                            </div>
                        </div>
                        <div className="col-lg-10">
                            <div className="primary_menu" id="menu">
                                <nav className="main_menu">
                                    <ul>
                                        <li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""}
                                                                           to="/">Home</NavLink></li>
                                        {/* <li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""} to="/about">About Us</NavLink></li> */}
                                        <li className="menu-item"><a href="#">About Us</a>
                                            <ul className="sub-menu">
                                                <li className="menu-item"><NavLink to="/about">About Us</NavLink>
                                                </li>
                                                <li className="menu-item"><Link to="/our_team">Our Team</Link></li>
                                            </ul>
                                        </li>
                                        <li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""}
                                                                           to="/services">Services</NavLink></li>
                                        <li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""}
                                                                           to="/portfolios">Portfolio</NavLink></li>
                                        {/*<li className="menu-item"><a href="#">Blog</a>
                                                <ul className="sub-menu">
                                                    <li className="menu-item"><NavLink to="/blog">Blog</NavLink></li>
                                                    <li className="menu-item"><Link to="/blog_details/1">Blog Details</Link></li>
                                                </ul>
                                            </li>*/}
                                        <li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""}
                                                                           to="/contact">Contact Us</NavLink></li>
                                        {/*<li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""} to="/careers">Careers</NavLink></li>*/}
                                        {/* <li className="menu-item"><Link className="deneb_btn" to="/contact">Hire Us</Link></li> */}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mobile_wrapper">
                    <div className="mobile_header">
                        <div className="row align-items-center">
                            <div className="col-6">
                                <div className="brand_logo">
                                    <Link to="/"><img src={siteLogo} className="img-fluid" alt="site logo"/></Link>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="menu_button">
                                    <div className={toggleMobileMenu ? "menu_icon active" : "menu_icon"}
                                         onClick={controlMobileMenu}>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={toggleMobileMenu ? "sidenav_menu active" : "sidenav_menu"}>
                        <div className="close_icon" onClick={closeMenu}>
                            <a href="#" className="close_btn"><i><FaTimes/></i></a>
                        </div>
                        <ul className="sidebar-menu">
                            <li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""}
                                                               to="/">Home</NavLink></li>
                            <li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""} to="/about">About
                                Us</NavLink></li>
                            <li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""} to="/our_team">Our Team</NavLink></li>
                            <li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""}
                                                               to="/services">Services</NavLink></li>
                            <li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""}
                                                               to="/portfolios">Portfolio</NavLink></li>
                      {/*      <li className="menu-item"><NavLink to="/blog">Blog</NavLink></li>
                            <li className="menu-item"><Link to="/blog_details/1">Blog Details</Link></li>*/}
                            <li className="menu-item"><NavLink className={({isActive}) => isActive ? "active_link" : ""} to="/contact">Contact
                                Us</NavLink></li>
                            {/* <li className="menu-item"><Link className="deneb_btn" to="/contact">Hire Us</Link></li> */}
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    )
}
